import { useEffect, useState } from 'react';

/** A picture's natural size, so a card can fit it whole. Null until it has loaded. */
export default function useImageSize(src) {
  const [size, setSize] = useState(null);
  useEffect(() => {
    setSize(null);
    if (!src) return undefined;
    let on = true;
    const img = new Image();
    img.onload = () => { if (on) setSize({ w: img.naturalWidth || img.width, h: img.naturalHeight || img.height }); };
    img.src = src;
    return () => { on = false; };
  }, [src]);
  return size;
}
